import { Navigate, Route, Routes } from 'react-router-dom';
import { Games } from './views/Games';
import { Join } from './views/Join';
import { Create } from './views/Create';
import { PlayNow } from './views/PlayNow';
import { SignIn } from './views/SignIn';
import { Builder } from './views/Builder';
import { Host } from './views/Host';
import { Board } from './views/Board';
import { Player } from './views/Player';
import { Admin } from './views/Admin';
import { SiteAdmin } from './views/SiteAdmin';
import { AccountList } from './views/AccountList';
import { Questions } from './views/Questions';
import { AddFriend, AddedYou, Friends } from './views/Friends';
import { Leaderboard } from './views/Leaderboard';
import { IdentityBar } from './components/IdentityBar';
import { Workshop } from './workshop/Workshop';

export function App() {
  return (
    <>
      <IdentityBar />
      {/* Load-bearing: full-height screens fill this flex column, not `#root`, or the page
          overflows by the bar's height. See `styles.css`'s "app frame" block. */}
      <div className="app-main">
        <Routes>
          {/* Create, Play Now and sign-in open as boards in the workshop, each at its own address. */}
          <Route path="/" element={<Workshop />} />
          <Route path="/join" element={<Join />} />
          <Route path="/games" element={<Games />} />
          <Route
            path="/create"
            element={
              <Workshop board="forge">
                <Create />
              </Workshop>
            }
          />
          <Route
            path="/play-now"
            element={
              <Workshop board="rack">
                <PlayNow />
              </Workshop>
            }
          />
          <Route
            path="/signin"
            element={
              <Workshop board="account">
                <SignIn />
              </Workshop>
            }
          />
          <Route path="/create/custom/new" element={<Builder />} />
          <Route path="/host/:code" element={<Host />} />
          <Route path="/board/:code" element={<Board />} />
          <Route path="/play/:code" element={<Player />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/:list" element={<AccountList />} />
          <Route path="/site-admin" element={<SiteAdmin />} />
          <Route path="/questions" element={<Questions />} />
          <Route path="/friends" element={<Friends />} />
          <Route path="/friends/add/:code" element={<AddFriend />} />
          <Route path="/friends/added-you" element={<AddedYou />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </>
  );
}
